import type { IMedia } from "src/model/unityObject";

export interface MediaPickerConstraints {
  allowedMediaTypes?: string;
  required360Tag?: string;
}

export type ConstraintCheck =
  | { ok: true }
  | { ok: false; reason: "type" | "tag"; expected: string; actual: string };

const isUnconstrained = (value?: string) => !value || value.trim() === "" || value === "all";

export const checkMediaAgainstConstraints = (
  media: Pick<IMedia, "type" | "media_360_tag">,
  constraints: MediaPickerConstraints,
): ConstraintCheck => {
  const { allowedMediaTypes, required360Tag } = constraints;

  if (!isUnconstrained(allowedMediaTypes)) {
    const allowed = (allowedMediaTypes ?? "")
      .split("|")
      .map((type) => type.trim())
      .filter(Boolean);
    const actual = media.type ?? "";
    if (!allowed.includes(actual)) {
      return { ok: false, reason: "type", expected: allowedMediaTypes ?? "", actual };
    }
  }

  if (!isUnconstrained(required360Tag)) {
    const actual = media.media_360_tag ?? "";
    if (actual !== required360Tag) {
      return { ok: false, reason: "tag", expected: required360Tag ?? "", actual };
    }
  }

  return { ok: true };
};
